import { render } from "./OAuth2ServiceAccount.vue?vue&type=template&id=d4f2adce"
import script from "./OAuth2ServiceAccount.vue?vue&type=script&lang=js"
export * from "./OAuth2ServiceAccount.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__